/* Calendario inline <iv-calendar> — replica react-day-picker + Calendar shadcn
   (CartCalendar dell'headless). Estratto da iv-cart-extras.liquid per essere
   riusato dalla pagina pickup-date (l'headless usa lo stesso componente).
   Attributi:
   - data-selected: ISO yyyy-mm-dd persistita (cart.attributes); se assente
                    "domani" è solo evidenziato visivamente, come sul live,
                    ma NON viene mai emesso come valore
   - data-blocked:  intervalli "start|end,start|end" (metaobject pickup_dates)
   - data-target:   id dell'input nascosto da valorizzare (default
                    iv-pickup-date-attr, il valore emesso è ISO+T00:00:00)
   - data-error:    id dell'elemento errore da nascondere alla selezione
                    (default iv-pickup-date-error)
   Al cambio selezione emette anche l'evento 'iv-calendar:change'. */
(function () {
  if (customElements.get('iv-calendar')) return;
  customElements.define(
    'iv-calendar',
    class extends HTMLElement {
      connectedCallback() {
        this.blocked = (this.dataset.blocked || '')
          .split(',')
          .filter(Boolean)
          .map(function (p) {
            var a = p.split('|');
            return {start: a[0], end: a[1]};
          });
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        this.today = today;
        this.tomorrow = new Date(today.getTime() + 86400000);
        // come il live: il valore emesso resta vuoto finché l'utente non
        // sceglie (o se già persistito in cart.attributes); domani è solo
        // il default visivo di CartCalendar
        this.selected = this.dataset.selected || '';
        var sel = this.parse(this.selected) || this.tomorrow;
        this.view = new Date(sel.getFullYear(), sel.getMonth(), 1);
        this.render();
        this.emit();
      }
      iso(d) {
        var m = String(d.getMonth() + 1).padStart(2, '0');
        var g = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + m + '-' + g;
      }
      parse(s) {
        if (!s) return null;
        var p = s.split('-');
        if (p.length !== 3) return null;
        return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      }
      isBlocked(iso) {
        return this.blocked.some(function (b) {
          return b.start && b.end && iso >= b.start && iso <= b.end;
        });
      }
      isDisabled(d) {
        // disabilitati: fino a oggi incluso ({before: tomorrow}) + intervalli metaobject
        return d < this.tomorrow || this.isBlocked(this.iso(d));
      }
      emit() {
        var attr = document.getElementById(this.dataset.target || 'iv-pickup-date-attr');
        if (attr) attr.value = this.selected ? this.selected + 'T00:00:00' : '';
        this.dispatchEvent(new CustomEvent('iv-calendar:change', {bubbles: true, detail: {iso: this.selected}}));
      }
      render() {
        var y = this.view.getFullYear();
        var m = this.view.getMonth();
        var first = new Date(y, m, 1);
        // highlight: la persistita/scelta, altrimenti domani (solo visivo)
        var visual = this.selected || this.iso(this.tomorrow);
        // locale it: la settimana parte da lunedì
        var offset = (first.getDay() + 6) % 7;
        var start = new Date(y, m, 1 - offset);
        var fmtMonth = new Intl.DateTimeFormat('it-IT', {month: 'long', year: 'numeric'});
        var fmtWd = new Intl.DateTimeFormat('it-IT', {weekday: 'short'});
        var html = '<div class="iv-cal__nav">';
        html +=
          '<button type="button" class="iv-cal__nav-btn" data-dir="-1" aria-label="Mese precedente">' +
          this.chev('left') +
          '</button>';
        html +=
          '<button type="button" class="iv-cal__nav-btn" data-dir="1" aria-label="Mese successivo">' +
          this.chev('right') +
          '</button>';
        html += '</div>';
        html += '<div class="iv-cal__caption">' + fmtMonth.format(first) + '</div>';
        html += '<div class="iv-cal__weekdays">';
        for (var i = 0; i < 7; i++) {
          var wd = new Date(2024, 0, 1 + i); // 1 gen 2024 = lunedì
          html += '<div class="iv-cal__weekday">' + fmtWd.format(wd).replace('.', '') + '</div>';
        }
        html += '</div><div class="iv-cal__grid">';
        for (var w = 0; w < 6; w++) {
          html += '<div class="iv-cal__week">';
          for (var d = 0; d < 7; d++) {
            var day = new Date(start.getFullYear(), start.getMonth(), start.getDate() + w * 7 + d);
            var iso = this.iso(day);
            var outside = day.getMonth() !== m;
            var disabled = this.isDisabled(day);
            var isSel = iso === visual && !disabled;
            var isToday = day.getTime() === this.today.getTime();
            var cls = 'iv-cal__day';
            if (outside) cls += ' is-outside';
            if (disabled) cls += ' is-disabled';
            if (isSel) cls += ' is-selected';
            if (isToday) cls += ' is-today';
            html +=
              '<div class="iv-cal__cell"><button type="button" class="' +
              cls +
              '" data-iso="' +
              iso +
              '"' +
              (disabled ? ' disabled' : '') +
              (isSel ? ' aria-selected="true"' : '') +
              '>' +
              day.getDate() +
              '</button></div>';
          }
          html += '</div>';
        }
        html += '</div>';
        this.innerHTML = html;
        var self = this;
        this.querySelectorAll('.iv-cal__nav-btn').forEach(function (b) {
          b.addEventListener('click', function () {
            self.view = new Date(self.view.getFullYear(), self.view.getMonth() + Number(b.dataset.dir), 1);
            self.render();
          });
        });
        this.querySelectorAll('.iv-cal__day:not([disabled])').forEach(function (b) {
          b.addEventListener('click', function () {
            self.selected = b.dataset.iso;
            self.emit();
            self.render();
            var err = document.getElementById(self.dataset.error || 'iv-pickup-date-error');
            if (err) err.hidden = true;
          });
        });
      }
      chev(dir) {
        var p = dir === 'left' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6';
        return (
          '<svg class="lucide" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
          p +
          '"/></svg>'
        );
      }
    }
  );
})();
